import { createStorefrontApiClient } from "@shopify/storefront-api-client";

export const client = createStorefrontApiClient({
  storeDomain: process.env.REACT_APP_SHOPIFY_URL!,
  publicAccessToken: process.env.REACT_APP_SHOPIFY_KEY!,
  apiVersion: "2025-10",
});
